import React from 'react';
import styles from './FieldCheckbox.module.scss';
import { FieldValidation } from '@/services/formSchema.service';
import classNames from 'classnames';

interface IFieldCheckbox {
    fieldInput: React.ReactElement;
    validation: FieldValidation;
    label: string;
    description?: string;
}

export const FieldCheckbox: React.FC<IFieldCheckbox> = ({ label, description, fieldInput, validation }) => (
    <>
        <div className={styles.checkboxWrapper}>
            <label className={styles.checkboxGroup}>
                {fieldInput}
                <div className={styles.checkboxBox} />
            </label>
            <div
                dangerouslySetInnerHTML={{ __html: label }}
                className={classNames(styles.checkboxLabel, {
                    [styles.checkboxLabelRequired]: validation.isRequired,
                })}
            />
        </div>
        {description && (
            <div dangerouslySetInnerHTML={{ __html: description }} className={styles.checkboxDescription} />
        )}
    </>
);
